import { Button } from "src/components";
import downArrow from "src/assets/down-arrow.svg";
import { useState } from "react";
import moment from "moment";
import { downloadInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";

interface OrderInfoFuidCardProps {
  fuid: any;
  index: number;
}

const OrderInfoFuidCard = ({ fuid, index }: OrderInfoFuidCardProps) => {
  const [isExpanded, setIsExpanded] = useState(index === 0);
  const { toast } = useToast();

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="mt-6 w-full mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-6 bg-white">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <div className="flex gap-6 items-center">
              <p className="font-semibold text-[1.3rem]">FUID {fuid?.invoice?.stockistInvoiceAttachment?.fuid_no}</p>
            </div>
            <div className="flex gap-2">
              <p
                className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full"
                style={{
                  backgroundColor: fuid?.invoice?.stockistInvoiceAttachment?.fileStatusHdr?.color_code?.trim(),
                  color: fuid?.invoice?.stockistInvoiceAttachment?.fileStatusHdr?.text_color_code?.trim(),
                }}
              >
                {fuid?.invoice?.stockistInvoiceAttachment?.fileStatusHdr?.fuid_status_desc}
              </p>
              <p className="font-semibold flex items-center w-fit mt-2 text-[.8rem] h-6 px-2 rounded-full bg-[#EAF4FF] text-[#002E6A]">
                {fuid?.order?.order_code}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              className="font-normal text-white bg-[#8051FF]"
              onClick={() => {
                if (!fuid?.invoice?.stockistInvoiceAttachment?.file_path) {
                  toast({ description: "Invoice not found", variant: "destructive" });
                  return;
                }

                toast({ title: "Downloading...", description: "Downloading invoice", variant: "default" });

                downloadInvoice(fuid?.invoice?.stockistInvoiceAttachment?.file_path).then((res: any) => {
                  if (res?.data?.success && res?.data?.data) {
                    window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                  } else {
                    console.error("Failed to download the invoice.");
                  }
                });
              }}
            >
              Download
            </Button>
            <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
              <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
            </Button>
          </div>
        </div>{" "}
        <div
          className={`transition-all items-center duration-500 ease-in-out ${isExpanded ? "opacity-100 max-h-[1000px]" : "max-h-0 opacity-0"}`}
          style={{ transitionProperty: "max-height, opacity" }}
        >
          <div className="border-t mt-6 border-[#d0d0d0]"></div>
          <div className="flex gap-10">
            <div className="mt-4 space-y-4 w-1/2">
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded on</p>
                <p className="text-[#303030]">{moment(fuid?.invoice?.stockistInvoiceAttachment?.created_date).format("MMMM Do YYYY")}</p>
              </div>
              <div className="text-[1rem] flex gap-20">
                <p className="text-[#616161]">Uploaded by</p>
                <p className="text-[#303030]">{fuid?.invoice?.stockistInvoiceAttachment?.uploader_name}</p>
              </div>
            </div>
            {fuid?.invoice?.stockistInvoiceAttachment?.invoiceRemarks.length > 0 && (
              <div className="mt-4 space-y-4 w-1/2">
                <p className="font-semibold text-[1.2rem]">Remarks</p>
                <p className="text-[#616161] inline-block mr-20">Category</p>
                <p className="text-[#303030] inline-block">
                  {fuid?.invoice?.stockistInvoiceAttachment?.RejectionInvoiceCategoryHdr?.rejection_inv_category_desc}
                </p>
                <div className="border space-y-1 mt-6 border-[#d0d0d0] min-h-[6rem] min-w-[20rem] w-fit rounded-lg bg-[#F1F1F1] p-4">
                  <p className="text-[#7F56D9] font-normal text-[1rem]">
                    {fuid?.invoice?.stockistInvoiceAttachment?.invoiceRemarks[0]?.remarkby_type}
                  </p>
                  <p className="text-[#303030] font-normal text-[1rem]">
                    <span className="font-semibold">
                      {" "}
                      {fuid?.invoice?.stockistInvoiceAttachment?.invoiceRemarks[0]?.invoiceRemarksHdr?.invoice_remarks_desc}
                    </span>{" "}
                    : ({fuid?.invoice?.stockistInvoiceAttachment?.invoiceRemarks[0]?.freetxt_remarks})
                  </p>
                  <p className="text-[#616161] font-normal text-[.8rem]">
                    {moment(fuid?.invoice?.stockistInvoiceAttachment?.invoiceRemarks[0]?.created_date).format("MMMM Do YYYY")}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderInfoFuidCard;
